/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

// import store from '../stores/Store';
import CheckHandler from '../../utils/CheckHandler';

const styles = {
  root: {},
};

class ITextFieldInner extends Component {
  static checkValue(value, props) {
    const { type, notNull, minLength, maxLength, label } = props;
    const { msg: helperText } = CheckHandler.checkParams([
      { key: label || '', value, notNull, type, maxLength, minLength },
    ]);
    return { helperText };
  }

  static determineType(type) {
    if (['date'].includes(type)) {
      return type;
    } else if (['weakPwd', 'strongPwd', 'password'].includes(type)) {
      return 'password';
    } else {
      return 'text';
    }
  }

  constructor() {
    super();
    this.state = {
      type: '',
      value: '',
      helperText: '',
      error: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const value = this.props.ivalue || '';
    const type = this.constructor.determineType(this.props.type);
    const { helperText } = this.constructor.checkValue(value, this.props);
    this.setState({
      type,
      value: this.props.ivalue, // 初始值
      helperText,
      error: helperText !== '' ? true : false,
    });
  }
  componentWillUnmount() { }


  handleChange(e) {
    console.log(`----- ITextField.handleChange.value: `, e.target.value);
    e.stopPropagation();
    const value = e.target.value;
    const { helperText } = this.constructor.checkValue(value, this.props);
    this.props.onChange(e); // 通知父节点
    this.setState({
      value,
      helperText,
      error: helperText !== '' ? true : false,
    });
  }

  render() {
    return (
      <>
        <TextField
          {...this.props}
          value={this.state.value}
          error={this.state.error}
          onChange={e => this.handleChange(e)}
          helperText={this.state.helperText}
          type={this.state.type}
        />
      </>
    );
  }

}

const ITextField = observer(ITextFieldInner);

ITextField.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ITextField);
